import { useState, useCallback, useEffect } from "react";

export const useSearch = (onSearchChange) => {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Debounce the search value
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [search]);

  // Trigger callback when debounced value changes
  useEffect(() => {
    if (onSearchChange) {
      onSearchChange(debouncedSearch);
    }
  }, [debouncedSearch, onSearchChange]);

  const handleSearch = useCallback((event) => {
    const searchValue = event.target.value.trim();
    setSearch(searchValue);
  }, []);

  const resetSearch = useCallback(() => {
    setSearch("");
    setDebouncedSearch("");
  }, []);

  return {
    search: debouncedSearch,
    handleSearch,
    resetSearch,
    setSearch,
  };
};